// assets/card-script.js
(function () {
  /* ------------------------------------------------------------
   * 1) ATC-napin tila + hintojen/ikonien näkyvyys
   * ---------------------------------------------------------- */
  function setCardBtnState(btn, isAvailable) {
    if (!btn) return;

    btn.toggleAttribute('disabled', !isAvailable);
    btn.setAttribute('aria-disabled', String(!isAvailable));
    btn.classList.toggle('is-disabled', !isAvailable);

    // Piilota/näytä mahdollinen "Sold out" -teksti
    const sold = btn.querySelector('.sold-out-message');
    if (sold) sold.classList.toggle('hidden', isAvailable);

    // Piilota/näytä hinnat (tyhjä harmaa nappi, kun ei saatavilla)
    const cur = btn.querySelector('.atc-price-current');
    const old = btn.querySelector('.atc-price-old');
    if (cur) cur.classList.toggle('hidden', !isAvailable);
    if (old) old.classList.toggle('hidden', !isAvailable);
  }

  /* ------------------------------------------------------------
   * 2) Päivitä ATC-napin labelit (nykyinen + vanha hinta)
   * ---------------------------------------------------------- */
  function setButtonText(atcBtn, priceText, compareText) {
    if (!atcBtn) return;

    const current = atcBtn.querySelector('.atc-price-current');
    const old     = atcBtn.querySelector('.atc-price-old');

    if (current) current.textContent = priceText || '';

    if (old) {
      const hasValidCompare = !!(compareText && compareText !== priceText);
      if (hasValidCompare) {
        old.textContent = compareText;
        old.classList.remove('hidden');
      } else {
        old.textContent = '';
        old.classList.add('hidden');
      }
    } else {
      // Fallback: jos teema ei sisällä erillisiä span-elementtejä
      const span = atcBtn.querySelector('span');
      if (span && priceText != null) span.textContent = priceText;
    }
  }

  /* ------------------------------------------------------------
   * 3) Korttien alustus
   * ---------------------------------------------------------- */
  function initCards(root = document) {
    root.querySelectorAll('.product-card-wrapper').forEach(function (card) {
      if (card.__cardInited) return;
      card.__cardInited = true;

      const variantBtns = card.querySelectorAll('.variant-btn');

      // Dawnin <product-form>
      const productForm = card.querySelector('product-form');
      const formEl = productForm ? productForm.querySelector('form') : null;
      const idInput = formEl ? formEl.querySelector('input[name="id"]') : null;
      const atcBtn  = formEl ? formEl.querySelector('button[type="submit"]') : null;

      let activeBtn = null;

      function updateDisplay(btn) {
        activeBtn = btn;

        const variantId  = btn?.dataset?.variantId;
        const priceText  = btn?.dataset?.price || '';
        const compareTxt = btn?.dataset?.compare || '';

        // Päivitä lomakkeen hidden id
        if (idInput && variantId) {
          idInput.value = variantId;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Päivitä hinnat napissa
        if (atcBtn) setButtonText(atcBtn, priceText, compareTxt);

        // Tila (näkyykö hinta vai tyhjä harmaa nappi)
        const isAvailable = !!(variantId && !btn.disabled && !btn.classList.contains('sold-out'));
        if (atcBtn) setCardBtnState(atcBtn, isAvailable);
      }

      // Etsi oletusvalinta: Original-ryhmän pienin ml, muuten pienin saatavilla oleva
      function getMl(btn) {
        const ds = btn.dataset && btn.dataset.ml ? parseFloat(String(btn.dataset.ml).replace(',', '.')) : NaN;
        if (!isNaN(ds)) return ds;
        const m = btn.textContent.match(/(\d+(?:[.,]\d+)?)\s*ml/i);
        return m ? parseFloat(m[1].replace(',', '.')) : Infinity;
      }

      const originalAvail = Array.from(variantBtns).filter(
        b => b.classList.contains('original-btn') && !b.disabled && !b.classList.contains('sold-out')
      );
      const anyAvail = Array.from(variantBtns).filter(
        b => !b.disabled && !b.classList.contains('sold-out')
      );

      let pick = null;
      if (originalAvail.length) {
        pick = originalAvail.slice().sort((a, b) => getMl(a) - getMl(b))[0];
      } else if (anyAvail.length) {
        pick = anyAvail.slice().sort((a, b) => getMl(a) - getMl(b))[0];
      }

      if (pick) {
        variantBtns.forEach(b => b.classList.remove('active'));
        pick.classList.add('active');
        updateDisplay(pick);
      } else {
        // Ei yhtään saatavilla olevaa varianttia → tyhjä harmaa nappi
        if (atcBtn) {
          const cur = atcBtn.querySelector('.atc-price-current');
          const old = atcBtn.querySelector('.atc-price-old');
          if (cur) { cur.textContent = ''; cur.classList.add('hidden'); }
          if (old) { old.textContent = ''; old.classList.add('hidden'); }
          setCardBtnState(atcBtn, false);
        }
      }

      // Vaihda varianttia
      variantBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (btn.disabled || btn.classList.contains('sold-out')) return;
          variantBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          updateDisplay(btn);
        });
      });

      // Submit: anna Dawnin hoitaa, mutta estä ilman aktiivista/saatavilla olevaa
      if (atcBtn && formEl) {
        atcBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!activeBtn || atcBtn.disabled) {
            e.preventDefault();
          }
        });
      }
    });

    // Estä overlay-klikki viemästä tuotesivulle
    root.querySelectorAll('.variant-atc-overlay').forEach(function (overlay) {
      if (overlay.__overlayInited) return;
      overlay.__overlayInited = true;
      overlay.addEventListener('click', function (e) { e.stopPropagation(); });
    });
  }

  /* ------------------------------------------------------------
   * 4) Autoinit uusille korteille
   * ---------------------------------------------------------- */
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches && node.matches('.product-card-wrapper')) {
          initCards(node);
        } else {
          const cards = node.querySelectorAll ? node.querySelectorAll('.product-card-wrapper') : [];
          if (cards.length) initCards(node);
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Init
  document.addEventListener('DOMContentLoaded', () => initCards(document));
  document.addEventListener('shopify:section:load', (e) => initCards(e.target));
  document.addEventListener('shopify:section:reorder', (e) => initCards(e.target));
})();
